@if (size !== 'none') {
  <div
    class="p-card py-2 px-3 word-wrap text-left"
    [ngClass]="{
      'max-w-12rem': size === 'large',
    }">
    <h3 class="flex align-items-center gap-2 my-1">
      @if (icons) {
        @for (icon of icons; track 'key') {
          <span
            class="flex align-items-center"
            [innerHTML]="icon.svg"
            [style]="{ fill: icon.color }"></span>
        }
      }
      @if (type === 'indicator' && indicators && indicators.length > 1) {
        Indikatoren
      } @else if (indicator) {
        {{ indicatorStore.getFullName(indicator) }}
      }
    </h3>
    <div
      class="flex"
      [ngClass]="{
        'flex-row gap-1': size === 'small',
        'flex-column': size === 'large',
      }">
      @if (type === 'indicator' && indicators) {
        @for (ind of indicators; track $index) {
          <div
            class="legend-item flex align-items-baseline text-left"
            [ngClass]="{
              'gap-1': size === 'small',
              'gap-2': size === 'large',
            }">
            <span
              class="legend-color flex flex-shrink-0"
              [style.background]="indicatorColors?.[$index]"></span>
            <span>{{ ind.name }}</span>
          </div>
        }
      }
      @for (scale of scales; track $index) {
        <div
          class="legend-item flex align-items-baseline text-left"
          [ngClass]="{
            'gap-1': size === 'small',
            'gap-2': size === 'large',
          }">
          <span
            class="legend-color flex flex-shrink-0"
            [style.background]="colors[$index]"></span>
          @if (scale.text) {
            {{ scale.text }}
          } @else {
            <span
              >{{
                scale.from
                  | safeNumber
                    : (isIndicator(indicator) ? indicator._id : undefined)
                    : true
                    : (isIndicator(indicator) ? undefined : indicator.unit)
              }}
              bis
              {{
                scale.to
                  | safeNumber
                    : (isIndicator(indicator) ? indicator._id : undefined)
                    : true
                    : (isIndicator(indicator) ? undefined : indicator.unit)
              }}</span
            >
          }
        </div>
      }
    </div>
    @if (comparisonData; as comparisons) {
      <div
        [ngClass]="{
          'flex-column': size === 'large',
          'flex-row gap-2 justify-content-end': size === 'small',
        }"
        class="pt-2 flex align-items-start text-xs text-left">
        @for (comparisonValue of comparisonStore.asArray(); track $index) {
          <div
            *ngIf="
              displayedComparisonValues?.includes(comparisonValue.key) &&
              comparisons?.[comparisonValue.key] as cVal
            ">
            <strong>{{ comparisonValue.name }}: </strong
            ><span>{{
              cVal
                | safeNumber
                  : (isIndicator(indicator) ? indicator._id : undefined)
                  : true
                  : (isIndicator(indicator) ? undefined : indicator.unit)
            }}</span>
          </div>
        }
      </div>
    }
  </div>
}
